import { useEditor, useNode } from "@craftjs/core";
import { ReactNode } from "react";
import Settings from "./Settings";

interface ContentContainerProps {
    children: ReactNode;
}

const ContentContainer = ({ children }: Partial<ContentContainerProps>) => {
    const {
        connectors: { connect },
    } = useNode();

    const { enabled } = useEditor((state) => ({
        enabled: state.options.enabled,
    }));

    if (enabled && !children)
        return (
            <div ref={(ref) => connect(ref!)} className="w-full p-3 bg-gray-200 rounded animate-pulse">
                This is an empty content container, add a suitable (button, filter, text container) components here.
            </div>
        );

    return (
        <div ref={(ref) => connect(ref!)} className="flex flex-col gap-6">
            {children}
        </div>
    );
};

export default ContentContainer;

ContentContainer.craft = {
    displayName: "Container",
    related: {
        settings: Settings,
    },
    rules: {
        canDrag: () => false,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        canDrop: (_: any, currentNode: any) =>
            currentNode.data.name === "StepButtonContainer" ||
            currentNode.data.name === "StepTextContainer" ||
            currentNode.data.name === "FilterContainer",
    },
};
